module.exports = __webpack_public_path__ + "img/peep.4ce76daf.svg";